module.exports = __webpack_public_path__ + "img/error-feet.8a14d6bc.svg";